import { CustomerInviteHook } from '@services';
import { useStore } from '@stores';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export const useCustomerEstimateReminderInvite = (
  customerId: string | undefined
): CustomerInviteHook => {
  const { customerStore } = useStore();
  const { customerEstimateReminderInvite, customerEstimateReminderInviteLoading } = customerStore;

  useEffect(() => {
    customerId &&
      customerStore.getEstimateReminderInvite({
        type: 'EstimateReminder',
        customerId,
        creationDate: dayjs().format(),
      });

    return () => {
      customerStore.clearCustomerEstimateReminderInvite();
    };
  }, [customerStore, customerId]);

  return {
    customerInvite: customerEstimateReminderInvite,
    loading: customerEstimateReminderInviteLoading,
  };
};
